export default __webpack_public_path__ + "c587f32ec70e6529df5d23c2746c6118.jpg";